import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Section, H1, Lead, Eyebrow } from "../components/Primitives";

export default function NotFoundPage() {
  return (
    <div data-testid="page-not-found">
      <Section className="pt-24 pb-32 text-center">
        <Eyebrow>404</Eyebrow>
        <H1 className="mx-auto mt-6 max-w-2xl">This register seems to be… on paper.</H1>
        <Lead className="mx-auto mt-6">The page you&apos;re looking for doesn&apos;t exist (yet). Let&apos;s get you back to a digital one.</Lead>
        <Link to="/" data-testid="notfound-cta">
          <Button className="mt-7 rounded-full bg-zinc-950 text-white hover:bg-zinc-800">Back to home</Button>
        </Link>
      </Section>
    </div>
  );
}
